import { Radio as AntDRadio } from 'antd';

import './Radio.css';

export type RadioProps = {
  checked: boolean;
  onClick?: () => void;
  dataTestId?: string;
  onChange?: () => void;
};

export function Radio({ checked, onClick, onChange, dataTestId }: RadioProps) {
  return <AntDRadio checked={checked} onClick={onClick} onChange={onChange} data-testid={dataTestId} />;
}
